import httpUtility from '../utils/http.utility.js'

import apiClient from './client.js'

async function getNotifications({ unread = false, page, pageSize } = {}) {
  const query = httpUtility.query({ unread: unread || undefined, page, itemsPerPage: pageSize })
  const response = await apiClient.get(`/notification?${query}`)
  return {
    notifications: response.data.notifications,
    total: response.data.total,
    unreadCount: response.data.unreadCount,
  }
}

async function getUnreadCount() {
  const response = await apiClient.get('/notification/unread-count')
  return response.data.unreadCount
}

async function markRead(id) {
  const response = await apiClient.patch(`/notification/${id}/read`)
  return response.data.notification
}

async function markAllRead() {
  return apiClient.patch('/notification/read-all')
}

async function deleteNotification(id) {
  return apiClient.delete(`/notification/${id}`)
}

class NotificationService {
  get = {
    /**
     * List notifications for the current user, newest first. Pass
     * `unread: true` to return only unread rows. The response also carries
     * the live unread count so a list refresh updates the badge.
     *
     * @param {{ unread?: boolean, page?: number, pageSize?: number }} [options]
     * @returns {Promise<{ notifications: object[], total: number, unreadCount: number }>} Unwrapped from `response.data`.
     */
    async list(options) {
      return getNotifications(options)
    },

    /**
     * Read just the unread badge count.
     *
     * @returns {Promise<number>} Unwrapped from `response.data.unreadCount`.
     */
    async unreadCount() {
      return getUnreadCount()
    },
  }

  update = {
    /**
     * Mark one notification read.
     *
     * @param {string} id
     * @returns {Promise<object>} The updated notification (`response.data.notification`).
     */
    async read(id) {
      return markRead(id)
    },

    /**
     * Mark every notification read.
     *
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async readAll() {
      return markAllRead()
    },
  }

  delete = {
    /**
     * Delete one notification.
     *
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async notification(id) {
      return deleteNotification(id)
    },
  }
}

export default new NotificationService()
